export class ToggleButton {
	constructor(element, options) {
		this.element = element

		this.options = {
			onText: element.getAttribute('data-text-on'),
			offText: element.getAttribute('data-text-off'),
			...options,
		}

		this.onText = this.options.onText
		this.offText = this.options.offText

		this.elSpan = element.querySelector('[data-text-label]')
		this.defaultText = this.elSpan.textContent
	}
	setText(text) {
		this.elSpan.textContent = text
	}
	on() {
		this.setText(this.onText)

		this.element.classList.add('is-toggled')
	}
	off() {
		this.setText(this.offText)
		this.element.classList.remove('is-toggled')
	}
	destroy() {
		this.setText(this.defaultText)
		this.element.classList.remove('is-toggled')
	}
}
